module.exports = "/Wow@2x-2ac5666bf486b79b0c91598d5c419094.png";